const PageHeadingComponent = ({ title = "", heading, subHeading }) => {
  return (
    <div className='container'>
      <div className='row pt-5'>
        <div className='col-12'>
          <h1 className='fs-1 fw-black lh-1' itemProp='headline'>
            {heading}
          </h1>
          {subHeading && (
            <div className='subheaderblock mb-3'>{subHeading}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeadingComponent;
